// src/pages/PaymentCallback.jsx
import { useEffect, useState } from "react";
import axios from "axios";

const MedicationPaymentCallback = () => {
  const [status, setStatus] = useState("Verifying payment...");

  useEffect(() => {
    const verifyPayment = async () => {
      try {
        const query = new URLSearchParams(window.location.search);
        const reference = query.get("reference");

        console.log({reference})

        if (!reference) {
          setStatus("Invalid payment reference");
          return;
        }

        const res = await axios.post(
          `${process.env.REACT_APP_BACKEND_URL}/prescription-payments/verify`,
          { reference }
        );

        if (res.data.success) {
          setStatus("✅ Payment successful. Admin has been notified.");
        } else {
          setStatus("⚠️ Payment verification failed");
        }
      } catch (err) {
        console.error(err);
        setStatus("❌ Error verifying payment");
      }
    };

    verifyPayment();
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-white">
      <div className="text-center">
        <h2 className="text-2xl font-semibold text-[#1E0E62] mb-4">
          Medication Payment
        </h2>
        <p className="text-gray-600">{status}</p>
      </div>
    </div>
  );
};

export default MedicationPaymentCallback;